module.exports = __webpack_public_path__ + "static/media/crepon.2e52bfbd.jpg";